import React, { useContext, useEffect, useState } from "react";
import { Button, Checkbox, FileUploader, IconInput, Input, Select, TagsInputs, UserNameInput } from "../../Components";
import { GroupRadios } from "../../Components/GroupRadios";
import * as Yup from 'yup';
import { FILE_SIZES, validationSchema } from "./validations";
import { useApi } from "../../Helpers/ApiHook";
import moment from "moment";
import { getFullName } from "../../Helpers/Functions";
import _ from "lodash";
import { DatePicker, DateRangePicker } from "rsuite";
import YearPicker from "../../Components/YearPicker";
import { AuthContext } from "../../Contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { TitleSection } from "./components";
import REGEX from "../../Constants/Regex";
import { type } from "@testing-library/user-event/dist/type";
import CustomAlert from "../../Components/CustomAlert";

const codeOfEthicsList = [
    "Facility Standards & Safety",
    "Qualified & Certified Staff",
    "Client-Centered Services",
    "Confidentiality & Privacy",
    "Honesty & Transparency",
    "Professional Boundaries",
    "Inclusively & Respect",
    "Ethical Marketing & Advertising",
    "Operational Excellence",
    "Legal & Regulatory Compliance"
]

const PRICING_PLANS_DEFAULT_STATE = {
    price: "",
    duration: "",
    note: "",
    features: []
};

const FULL_HOURS_DEFAULT_STATE = {
    Mon: ['5:00 AM', "10:00 PM"],
    Tue: ['5:00 AM', "10:00 PM"],
    Wed: ['5:00 AM', "10:00 PM"],
    Thu: ['5:00 AM', "10:00 PM"],
    Fri: ['5:00 AM', "10:00 PM"],
    Sat: ['5:00 AM', "10:00 PM"],
    Sun: [null, null]
}

const SERVICES_DEFAULT_STATE = { img: "", title: '', price: '' };

const YOUTUBE_LINKS_DEFAULT_STATE = { title: '', channel: "Youtube", link: "" };

const KEY_POINTS_DEFAULT_STATE = [
    { name: "5.0 Hygiene Rating", img: '/assets/gym-facilities/drop-plus.png', status: false },
    { name: "Certified Trainers", img: '/assets/gym-facilities/certified.png', status: false },
    { name: "Premium Equipments", img: '/assets/gym-facilities/hand-setting.png', status: false },
]

const DEFAULT_VALUES = {
    facility_name: '',
    user_name: '',
    owner_first_name: "",
    owner_last_name: '',
    email: '',
    est_year: "",
    phone_no: '',
    whatsapp_no: '',
    academic_qualification: "",
    city_id: '',
    state_id: '',
    country_id: '',
    pincode: '',
    full_address: '',
    navigation_url: "",
    experiance_yrs: '',
    social_links: {
        instagram: "",
        facebook: "",
        linkedin: "",
        youtube: "",
    },
    notes: '',
    key_points: KEY_POINTS_DEFAULT_STATE,
    aadhar_card: '',
    pan_card: '',
    registration_docs: '',
    trainer_certificates: '',
    electricity_bill: '',
    lease_agreement: '',
    full_hours: {
        Mon: '5:00 AM - 10:00 PM',
        Tue: '5:00 AM - 10:00 PM',
        Wed: '5:00 AM - 10:00 PM',
        Thu: '5:00 AM - 10:00 PM',
        Fri: '5:00 AM - 10:00 PM',
        Sat: '5:00 AM - 10:00 PM',
        Sun: ''
    },
    services: [SERVICES_DEFAULT_STATE],
    pricing_plans: [PRICING_PLANS_DEFAULT_STATE],
    youtube_links: [YOUTUBE_LINKS_DEFAULT_STATE],
    amenities: [],
    codeOfEthics: false,
}

const CreateGymProfile = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const { user, getUserDetails } = useContext(AuthContext);

    const isMyProfilePage = location.pathname === '/my-profile';
    const user_id = user?.gym_details?.id || null;

    const { get, postFormData } = useApi()

    const [isLoading, setIsLoading] = useState(true)
    const [isLoadingState, setIsLoadingState] = useState(false)
    const [isLoadingCities, setIsLoadingCities] = useState(false)
    const [isSubmitting, setIsSubmitting] = useState(false)
    const [formData, setFormData] = useState(DEFAULT_VALUES);
    const [countries, setCountries] = useState([])
    const [stateList, setStateList] = useState([])
    const [cities, setCities] = useState([]);
    const [isValidUserName, setValidUserName] = useState(false);

    const [amenityList, setAmenityList] = useState([]);
    const [planFeatures, setPlanFeatures] = useState([]);

    const [errors, setErrors] = useState({});

    const _getGymDetails = async () => {
        setIsLoading(true);
        try {
            const response = await get(`gyms/show/${user_id}`);
            if (response?.status) {

                const responseData = response?.data || {}
                const key_points = (responseData?.key_points || []).map((kp, index) => ({ ...kp, status: kp.status ? 1 : 0 }))
                await setFormData({
                    ...DEFAULT_VALUES,
                    ...responseData,
                    ...responseData?.location,
                    documents: {
                        aadhar_card: responseData?.aadhar_card || null,
                        registration_docs: responseData?.registration_docs || null,
                        lease_agreement: responseData?.lease_agreement || null,
                        trainer_certificates: responseData?.trainer_certificates || null,
                        electricity_bill: responseData?.electricity_bill || null,
                        pan_card: responseData?.pan_card || null,
                        logo_img: responseData?.logo_img,
                        banner_img: responseData?.banner_img
                    },
                    aadhar_card: "",
                    registration_docs: "",
                    trainer_certificates: "",
                    lease_agreement: "",
                    electricity_bill: "",
                    pan_card: "",
                    logo_img: "",
                    banner_img: "",
                    codeOfEthics: true,
                    user_name: responseData?.user_name || "",
                    key_points: key_points
                })


                const pricing_plans_features = (responseData?.pricing_plans?.[0]?.features || []).map(feature => feature.title) || [];
                // console.log(pricing_plans_features)
                await setPlanFeatures(pricing_plans_features || []);

                if (!!responseData?.user_name) {
                    await setValidUserName(true);
                }
            }
        } catch (error) {
            console.error("Error fetching Gyms: ", error);
        } finally {
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isMyProfilePage) {
            _getGymDetails();
        }
        _getAmenities()
        _getCountry()
    }, []);

    useEffect(() => {
        if (!!formData.country_id) {
            _getState()
        } else {
            setStateList([])
        }
    }, [formData.country_id])

    useEffect(() => {
        if (!!formData.country_id && !!formData?.state_id) {
            _getCities()
        } else {
            setCities([])
        }
    }, [formData?.state_id])

    const _getCountry = async () => {
        await setIsLoading(true);
        await get("countries/list", {
            params: {

            }
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setCountries(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const _getAmenities = async () => {
        await setIsLoading(true);
        await get("amenities/list", {
            params: {

            }
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setAmenityList(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            // setIsLoading(false);
        });
    }

    const _getState = async () => {
        await setIsLoadingState(true);
        await get(`states/${formData.country_id}`, {
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setStateList(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoadingState(false);
        });
    }

    const _getCities = async () => {
        await setIsLoadingCities(true);
        await get(`cities/${formData?.state_id}`, {
        }).then((data) => {
            // console.log("🚀 ~ _getState ~ data?.data:", data)
            if (data.status) {
                setCities(data?.data || []);
            }
        }).catch((error) => {
            console.error("Error fetching trainers: ", error);
        }).finally(() => {
            setIsLoadingCities(false);
        });
    }


    const handleChange = (e, regex = null) => {
        const { name, value, type, checked } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : !!regex ? (value || "").replace(regex, "") : value
        }));

        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({ ...prev, [name]: '' }));
        }
    };

    const handleTagChange = (keyName, tags) => {
        setFormData(prev => ({
            ...prev,
            [keyName]: tags
        }));
    };

    const validateField = async (fieldName, value) => {
        try {
            await validationSchema.validateAt(fieldName, { [fieldName]: value });
            setErrors(prev => ({ ...prev, [fieldName]: '' }));
        } catch (err) {
            setErrors(prev => ({ ...prev, [fieldName]: err.message }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        await setIsSubmitting(true)
        try {
            // console.log(formData)
            await validationSchema.validate(formData, { abortEarly: false });
            // console.log('Form Data:', formData);
            await setErrors({});
            await onSubmitTrainerDetails();
            // alert('Form submitted successfully!');
            // Handle form submission here
        } catch (err) {
            const validationErrors = {};
            err.inner.forEach(error => {
                validationErrors[error.path] = error.message;
            });
            // console.log(validationErrors)
            setErrors(validationErrors);
            setIsSubmitting(false)
        }
    };

    const onSubmitTrainerDetails = async () => {
        try {

            const trainerFormData = new FormData();

            const amenities = formData?.amenities.map((amt_details, index) => ({ img: amt_details?.img, title: amt_details?.title }))

            Object.entries({ ...formData, amenities: amenities }).forEach(([key, value]) => {

                const appendValue = (path = "", val = "") => {
                    if (val instanceof File || val instanceof Blob) {
                        trainerFormData.append(path, val, val.name); // ✅ use filename here
                    } else if (typeof val === "object" && val !== null) {
                        trainerFormData.append(path, JSON.stringify(val));
                    } else {
                        trainerFormData.append(path, "" + (val ?? ""));
                    }
                };

                const objectAppend = (path = "", val = {}) => {
                    if (Array.isArray(val)) {
                        val.forEach((item, i) => {
                            if (typeof item === 'object') {
                                objectAppend(`${path}[${i}]`, item)
                            } else {
                                appendValue(`${path}[${i}]`, item);
                            }
                        });
                    } else if (val instanceof File || val instanceof Blob) {
                        appendValue(`${path}`, val || null);
                    } else {
                        Object.entries({ ...val }).forEach(([subKey, subVal]) => {
                            if (typeof subVal === 'object') {
                                objectAppend(`${path}[${subKey}]`, subVal)
                            } else {
                                appendValue(`${path}[${subKey}]`, subVal);
                            }
                        });
                    }
                }

                if (Array.isArray(value)) {
                    value.forEach((item, i) => {
                        if (Array.isArray(item)) {
                            item.forEach((item, i) => {
                                if (typeof item === 'object') {
                                    objectAppend(`${key}[${i}]`, item)
                                } else {
                                    appendValue(`${key}[${i}]`, item);
                                }
                            });
                        } else if (typeof item === 'object') {
                            objectAppend(`${key}[${i}]`, item)
                        } else {
                            appendValue(`${key}[${i}]`, item);
                        }
                    });
                } else if (typeof value === 'object' && value !== null) {
                    objectAppend(`${key}`, value || "")
                } else {
                    appendValue(key, value);
                }
            });

            trainerFormData.append('owner_full_name', getFullName({ first_name: formData?.owner_first_name, last_name: formData.owner_last_name }));

            const urlPath = (isMyProfilePage ? `gyms/update/${user_id}` : "gyms/store");

            const response = await postFormData(urlPath, trainerFormData)

            if (!!response?.status) {
                if (isMyProfilePage) {
                    CustomAlert({
                        type: "success",
                        title: "My Profile Update",
                        message: 'Gym profile successfully updated.',
                        confirmText: 'Okay',
                        onConfirm: (e) => {
                            onUpdateLocalData()
                        }
                    })
                } else {
                    CustomAlert({
                        type: "success",
                        title: "Gym Facility/Studio Create",
                        message: 'Gym Facility/Studio successfully created',
                        confirmText: 'Okay',
                        onConfirm: (e) => {
                            onUpdateLocalData()
                        }
                    })
                }
            }
        } catch (e) {
            // console.log(e)
        } finally {
            setIsSubmitting(false)
        }
    }

    const onUpdateLocalData = async () => {
        await navigate(-1);
        await getUserDetails()
    }

    const handleReset = () => {
        setFormData(DEFAULT_VALUES);
        setErrors({});
    };

    const addPricingPlan = () => {
        const new_features = [...planFeatures].map((featureName) => ({ status: false, title: featureName }))
        setFormData(prev => ({
            ...prev,
            pricing_plans: [...prev.pricing_plans, { ...PRICING_PLANS_DEFAULT_STATE, features: new_features }]
        }));
    };

    const removePricingPlan = (index) => {
        setFormData(prev => ({
            ...prev,
            pricing_plans: prev.pricing_plans.filter((_, i) => i !== index)
        }));
    };

    const handlePricingPlanChange = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            pricing_plans: prev.pricing_plans.map((service, i) =>
                i === index ? { ...service, [field]: value } : service
            )
        }));
    };

    const addService = () => {
        setFormData(prev => ({
            ...prev,
            services: [...prev.services, SERVICES_DEFAULT_STATE]
        }));
    };

    const removeService = (index) => {
        setFormData(prev => ({
            ...prev,
            services: prev.services.filter((_, i) => i !== index)
        }));
    };

    const handleServiceChange = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            services: prev.services.map((service, i) =>
                i === index ? { ...service, [field]: value } : service
            )
        }));
    };


    const addYoutubeLink = () => {
        setFormData(prev => ({
            ...prev,
            youtube_links: [...prev.youtube_links, YOUTUBE_LINKS_DEFAULT_STATE]
        }));
    };

    const removeYoutubeLink = (index) => {
        setFormData(prev => ({
            ...prev,
            youtube_links: prev.youtube_links.filter((_, i) => i !== index)
        }));
    };

    const handleYoutubeChange = (index, field, value) => {
        setFormData(prev => ({
            ...prev,
            youtube_links: prev.youtube_links.map((link_details, i) =>
                i === index ? { ...link_details, [field]: value } : link_details
            )
        }));
    };
    // console.log('est_year =>', typeof formData?.est_year)
    return (
        <div className="w-full bg-gradient-radial flex flex-col">
            <style jsx="true" global="true">
                {`
                    :root{
                        --rs-input-bg: #22262E;
                        --rs-bg-overlay: #22262E;
                        --rs-border-primary: rgb(55 65 81 / var(--tw-border-opacity, 1));
                        --rs-focus-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
                        --rs-input-focus-border: rgb(255 255 255 / var(--tw-ring-opacity, 1));
                        --rs-text-primary: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-btn-subtle-text: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-text-secondary: rgb(107 114 128 / var(--tw-text-opacity, 1));
                        --rs-calendar-cell-selected-hover-bg: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-btn-primary-hover-bg: rgb(156 163 175 / var(--tw-text-opacity, 1));
                        --rs-bg-active: #ffffff;
                        --rs-calendar-date-selected-text: #22262E;
                        --rs-listbox-option-hover-bg: rgb(55 65 81 / var(--tw-border-opacity, 1));
                        --rs-listbox-option-hover-text: #ffffff;
                        --rs-btn-primary-text: #22262E;
                        --rs-btn-primary-bg: var(--rs-gray-0);
                        --rs-btn-primary-border-color: var(--rs-gray-0);
                        --rs-btn-link-hover-text: rgb(255 255 255 / var(--tw-ring-opacity, 0.6));
                        --rs-btn-link-text: #ffffff;
                        --rs-input-disabled-bg: #22262E;
                    }

                    
                `}
            </style>
            <TitleSection
                title="List Your Gym Facility/Studio Under FWPI"
            />
            <div className='w-full bg-gradient-radial'>
                <div className="container mx-auto px-4 lg:px-10">
                    {
                        isLoading ?
                            <div className="max-w-6xl font-urbanist rounded-lg mx-auto space-y-8 bg-[#181B23] text-white py-12 px-12 lg:px-32" >
                                <div className="w-full flex justify-center items-center">
                                    <span
                                        className="inline-block w-10 h-10 border-2 border-gray-400 border-t-transparent rounded-full animate-spin mr-2"
                                    ></span>
                                </div>
                            </div>
                            :
                            <div className="max-w-6xl font-urbanist rounded-lg mx-auto space-y-8 bg-[#181B23] text-white py-6 px-6 md:px-12 lg:px-32" >
                                <Input
                                    label="Official Name of the Facility"
                                    subTitle="(Gym, Studio, Wellness Center, etc.)"
                                    placeholder="Enter Your Official Name of the Facility"
                                    id="facility_name"
                                    name="facility_name"
                                    value={formData.facility_name}
                                    onChange={handleChange}
                                    errors={errors}
                                    required
                                    disabled={isSubmitting}
                                />


                                <UserNameInput
                                    user_id={user_id || null}
                                    category="gym"
                                    value={formData.user_name}
                                    onChange={(e) => { handleChange(e, REGEX.USER_NAME_REGEX) }}
                                    errors={errors}
                                    required={true}
                                    disabled={isSubmitting}
                                    onStatusChange={({ status, isExist, username }) => {
                                        // console.log("status", status, "isExist", isExist, "username", username);
                                        if (isExist === true) {
                                            setValidUserName(true);
                                        } else {
                                            setValidUserName(false);
                                        }
                                        // isExist === true  => username exists (available)
                                        // isExist === false => username available
                                        // isExist === null  => other states (tooShort, checking, invalid, error, idle)
                                    }}
                                />

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8">
                                    <Input
                                        label="First Name"
                                        subTitle={'Legal Name of Owner / Authorized Representative'}
                                        id="owner_first_name"
                                        name="owner_first_name"
                                        value={formData.owner_first_name}
                                        placeholder="Enter Your First Name"
                                        onChange={handleChange}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />
                                    <Input
                                        label="Last Name"
                                        subTitle={'Legal Name of Owner / Authorized Representative'}
                                        id="owner_last_name"
                                        name="owner_last_name"
                                        value={formData.owner_last_name}
                                        onChange={handleChange}
                                        errors={errors}
                                        placeholder="Enter Your Last Name"
                                        required
                                        disabled={isSubmitting}
                                    />
                                </div>


                                <Input
                                    label="Highest Academic Qualification"
                                    placeholder="Enter Your Highest Academic Qualification"
                                    id="academic_qualification"
                                    name="academic_qualification"
                                    type="text"
                                    value={formData?.academic_qualification}
                                    onChange={handleChange}
                                    errors={errors}
                                    required
                                    disabled={isSubmitting}
                                />

                                {/* Row 1: Full Name */}
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-8">
                                    <YearPicker
                                        label="Facility Establishment Year"
                                        id="est_year"
                                        name="est_year"
                                        minYear={'1950'}
                                        maxYear={moment().format('YYYY')}
                                        rows={3}
                                        columns={3}
                                        placeholder="Select year"
                                        value={formData.est_year || ""}
                                        disabled={isSubmitting}
                                        errors={errors}
                                        onChange={(year) => {
                                            // console.log('est_year', year)
                                            handleTagChange('est_year', year);
                                        }}
                                    />

                                    <Input
                                        label="Primary Email"
                                        id="email"
                                        name="email"
                                        type="email"
                                        value={formData?.email}
                                        onChange={handleChange}
                                        errors={errors}
                                        placeholder="Enter Your Primary Email"
                                        required
                                    />

                                    <IconInput
                                        src="https://flagcdn.com/in.svg"
                                        label="Registered Contact No. - WhatsApp Preferred"
                                        id="phone_no"
                                        name="phone_no"
                                        type="tel"
                                        value={formData?.phone_no}
                                        onChange={(e) => handleChange(e, /[^0-9]/, "")}
                                        errors={errors}
                                        placeholder="0000000000"
                                        maxLength={10}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <IconInput
                                        src="https://flagcdn.com/in.svg"
                                        label="WhatsApp Number"
                                        id="whatsapp_no"
                                        name="whatsapp_no"
                                        value={formData?.whatsapp_no}
                                        onChange={(e) => handleChange(e, /[^0-9]/, "")}
                                        errors={errors}
                                        type="tel"
                                        placeholder="0000000000"
                                        maxLength={10}
                                        required
                                        disabled={isSubmitting}
                                    />

                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Address :-
                                    </p>

                                    {/* Full Address */}
                                    <Input
                                        type='textarea'
                                        label="Gym / Studio official Address"
                                        id="full_address"
                                        name="full_address"
                                        placeholder="Enter Your Gym / Studio official Address"
                                        onChange={handleChange}
                                        errors={errors}
                                        value={formData?.full_address}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    {/* Row 4: City and State */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">

                                        <Select
                                            label="City of Residence"
                                            id="country_id"
                                            name="country_id"
                                            placeholder="Enter Your Country of Residence"
                                            onChange={handleChange}
                                            options={countries}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.country_id}
                                            required
                                            disabled={isSubmitting}
                                        />

                                        <Select
                                            loading={isLoadingState}
                                            label="State of Residence"
                                            id="state_id"
                                            name="state_id"
                                            placeholder="Enter Your State of Residence"
                                            onChange={handleChange}
                                            options={stateList}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.state_id}
                                            required
                                            disabled={isSubmitting}
                                        />
                                        <Select
                                            loading={isLoadingCities}
                                            label="City of Residence"
                                            id="city_id"
                                            name="city_id"
                                            placeholder="Enter Your City of Residence"
                                            onChange={handleChange}
                                            options={cities}
                                            schema={{
                                                name: "name",
                                                value: "id"
                                            }}
                                            errors={errors}
                                            value={formData?.city_id}
                                            required
                                            disabled={isSubmitting}
                                        />
                                        <Input
                                            label="Area PIN Code"
                                            id="pincode"
                                            name="pincode"
                                            placeholder="Enter Your Area PIN Code"
                                            onChange={handleChange}
                                            errors={errors}
                                            value={formData?.pincode}
                                            required
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Social Media Links :-
                                    </p>

                                    {/* Certifications and Instagram URL */}
                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                        {
                                            Object.keys(DEFAULT_VALUES.social_links).map((urlKey, index) => {
                                                return (
                                                    <Input
                                                        key={index}
                                                        label={`${_.capitalize(urlKey)} URL`}
                                                        id={urlKey}
                                                        name={urlKey}
                                                        type="url"
                                                        placeholder={`Enter Your ${_.capitalize(urlKey)} URL`}
                                                        value={formData?.social_links?.[urlKey]}
                                                        onChange={(event) => {
                                                            const name = event.target.name || "";
                                                            const value = event.target.value || "";
                                                            setFormData((prevState) => ({
                                                                ...prevState,
                                                                social_links: {
                                                                    ...formData?.social_links,
                                                                    [name]: value
                                                                }
                                                            }));
                                                        }}
                                                        errors={errors}
                                                        required={false}
                                                        disabled={isSubmitting}
                                                    />
                                                )
                                            })
                                        }
                                    </div>
                                </div>

                                <div className="w-full flex flex-col justify-center gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Professional Information :-
                                    </p>

                                    {/* About Us */}

                                    <Input
                                        type='textarea'
                                        label="Optional Message or Note"
                                        id="notes"
                                        name="notes"
                                        placeholder="Enter Your Optional Message or Note"
                                        onChange={handleChange}
                                        errors={errors}
                                        value={formData?.notes}
                                        required
                                        disabled={isSubmitting}
                                    />

                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-6">
                                        <Input
                                            type="number"
                                            label="Experience"
                                            id="experiance_yrs"
                                            name="experiance_yrs"
                                            placeholder="Enter Your Experience"
                                            value={formData.experiance_yrs || ""}
                                            onChange={handleChange}
                                            errors={errors}
                                            required
                                        />
                                        <Input
                                            label="Navigation Url"
                                            id="navigation_url"
                                            name="navigation_url"
                                            value={formData?.navigation_url}
                                            onChange={handleChange}
                                            errors={errors}
                                            placeholder="Enter Your Navigation Url"
                                            disabled={isSubmitting}
                                        />
                                    </div>
                                    <div className="w-full font-urbanist">
                                        <label
                                            className={`block text-lg font-semibold mb-1 ${isSubmitting ? "text-gray-500" : "text-white"}`}
                                        >
                                            Key Points <span className="text-red-600">*</span>
                                        </label>

                                        <div className="w-full flex flex-row flex-wrap justify-start items-center gap-6">
                                            {
                                                (formData.key_points || []).map((pointDetails, index) => {
                                                    const radiusClass = 'rounded-tl-md';
                                                    return (
                                                        <div className="flex flex-row items-center justify-center gap-3" key={index}>
                                                            <input
                                                                type="checkbox"
                                                                className="mt-0"
                                                                name="status"
                                                                checked={!!pointDetails?.status}
                                                                style={{ height: '1.2rem', width: '1.2rem' }}
                                                                onChange={(event) => {
                                                                    const checked = event.target.checked;
                                                                    const key_points = [...formData.key_points];
                                                                    key_points[index]['status'] = checked ? 1 : 0;
                                                                    handleTagChange('key_points', key_points)
                                                                }}
                                                                disabled={isSubmitting}
                                                            />
                                                            <div
                                                                className={`flex flex-row items-center bg-[#22262E] px-5 py-2 md:py-2 rounded-3xl ${radiusClass} gap-3`}
                                                            >
                                                                <img
                                                                    src={pointDetails.img}
                                                                    className="w-4 h-4"
                                                                    alt={pointDetails.name}
                                                                />
                                                                <div className="text-white text-[0.75rem] font-normal font-urbanist leading-normal">
                                                                    {pointDetails.name}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>
                                    <div className="w-full font-urbanist">
                                        <label
                                            className={`block text-lg font-semibold mb-1 ${isSubmitting ? "text-gray-500" : "text-white"}`}
                                        >
                                            Working Hours <span className="text-red-600">*</span>
                                        </label>

                                        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                                            {
                                                Object.keys({ ...FULL_HOURS_DEFAULT_STATE }).map((dayName, index) => {
                                                    const selectedDayValues = (formData?.full_hours?.[dayName] || "").split(' - ');

                                                    const fromTime = selectedDayValues?.[0] || FULL_HOURS_DEFAULT_STATE[dayName][0] || null;
                                                    const toTime = selectedDayValues?.[1] || FULL_HOURS_DEFAULT_STATE[dayName][1] || null;

                                                    const formValue = !!fromTime ? moment(fromTime, "hh:mm A").local().toDate() : null;
                                                    const toValue = !!toTime ? moment(toTime, 'hh:mm A').local().toDate() : null;

                                                    return (
                                                        <div className="flex flex-col items-start justify-center gap-1" key={index}>
                                                            <div className="font-urbanist font-semibold text-lg">
                                                                {dayName}
                                                            </div>
                                                            <div className="w-full flex flex-row justify-between">
                                                                <DateRangePicker
                                                                    format="hh:mm aa"
                                                                    showMeridian
                                                                    character=" - "
                                                                    ranges={[]}
                                                                    // oneTap
                                                                    block={true}
                                                                    cleanable={true}
                                                                    value={[formValue, toValue]}
                                                                    onChange={(dates) => {
                                                                        const [from, to] = dates || [];
                                                                        const valueString = !!dates ? [moment(from).format("hh:mm A"), moment(to).format("hh:mm A")] : [];
                                                                        setFormData((prevState) => ({
                                                                            ...prevState,
                                                                            full_hours: {
                                                                                ...formData?.full_hours,
                                                                                [dayName]: !!dates ? valueString.join(" - ") : ""
                                                                            }
                                                                        }));
                                                                    }}
                                                                    disabled={isSubmitting}
                                                                />

                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    </div>

                                </div>

                                <div className="w-full flex flex-col justify-center  gap-x-6 gap-y-6">

                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Required Documents :-
                                    </p>

                                    {/* File Upload: Professional Photo */}
                                    <FileUploader
                                        label="Logo Image"
                                        id="logo_img"
                                        uploadedImage={formData?.documents?.logo_img || null}
                                        name="logo_img"
                                        accept='.png, .jpg, .jpeg'
                                        sizeInMb={FILE_SIZES.PROFILE_FILE_SIZE}
                                        required
                                        maxFiles={1}
                                        onChange={(event) => {
                                            handleTagChange('logo_img', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    <FileUploader
                                        label="Banner Image"
                                        id="banner_img"
                                        uploadedImage={formData?.documents?.banner_img || null}
                                        name="banner_img"
                                        accept='.png, .jpg, .jpeg'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.BANNER_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('banner_img', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* File Upload: Aadhaar Card */}
                                    <FileUploader
                                        label="Provide Valid Identity Proof Aadhar"
                                        subTitle={`(Owner)`}
                                        id="aadhar_card"
                                        uploadedImage={formData?.documents?.aadhar_card || null}
                                        name="aadhar_card"
                                        accept='.pdf'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.AADHAR_CARD_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('aadhar_card', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                    <FileUploader
                                        label="Provide Valid Identity Proof PAN"
                                        subTitle={`(Owner)`}
                                        id="pan_card"
                                        uploadedImage={formData?.documents?.pan_card || null}
                                        name="pan_card"
                                        accept='.pdf'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.PAN_CARD_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('pan_card', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* Educational Qualification Upload */}
                                    <FileUploader
                                        label="Submit Copies of All Trainers Qualification Certificates"
                                        id="trainer_certificates"
                                        uploadedImage={formData?.documents?.trainer_certificates || null}
                                        name="trainer_certificates"
                                        accept='.pdf'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.TRAINER_CERTIFICATES_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('trainer_certificates', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />

                                    {/* Valid Certificates Upload */}
                                    <FileUploader
                                        label="Attach Business Registration Certificate"
                                        id="registration_docs"
                                        uploadedImage={formData?.documents?.registration_docs || null}
                                        name="registration_docs"
                                        accept='.pdf'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.REGISTRATION_DOCS_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('registration_docs', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                    <FileUploader
                                        label="Provide Recent Electricity Bill"
                                        subTitle={`(Gym Facility, Studio)`}
                                        id="electricity_bill"
                                        uploadedImage={formData?.documents?.electricity_bill || null}
                                        name="electricity_bill"
                                        accept='.pdf'
                                        required
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.ELECTRICITY_BILL_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('electricity_bill', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                    <FileUploader
                                        label="Upload Rent / Lease Agreement"
                                        subTitle={`(if property is rented)`}
                                        id="lease_agreement"
                                        uploadedImage={formData?.documents?.lease_agreement || null}
                                        name="lease_agreement"
                                        accept='.pdf'
                                        maxFiles={1}
                                        sizeInMb={FILE_SIZES.LEASE_AGREEMENT_FILE_SIZE}
                                        onChange={(event) => {
                                            handleTagChange('lease_agreement', event.target.files)
                                        }}
                                        errors={errors}
                                        disabled={isSubmitting}
                                    />
                                </div>

                                <div className="space-y-4">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Pricing Plans :-
                                    </p>

                                    <TagsInputs
                                        label="Manage Features for Plans"
                                        subTitle={`First, add features here. After that, they should automatically appear in the “Features” section of the plans.`}
                                        id="planFeatures"
                                        name="planFeatures"
                                        placeholder="Write feature and press enter to add feature tags"
                                        value={planFeatures || []}
                                        onChange={(tags) => {
                                            setPlanFeatures(tags);
                                            setFormData((prevState) => ({
                                                ...prevState,
                                                pricing_plans: formData.pricing_plans.map((planDetails) => {
                                                    const features_tags = [...tags].map((tagName) => {
                                                        const isExistFeature = _.find(planDetails.features || [], ['title', tagName]);
                                                        return (!!isExistFeature ? isExistFeature : { status: false, title: (tagName || "") });
                                                    })

                                                    return { ...planDetails, features: features_tags }
                                                })
                                            }))
                                        }}
                                        errors={errors}
                                        required
                                        disabled={isSubmitting}
                                    />
                                    {
                                        (formData.pricing_plans || []).map((planDetails, index) => {
                                            return (
                                                <div key={index} className="bg-[#22262E] border border-gray-600 p-4 rounded-lg space-y-4">
                                                    <div className="flex justify-between items-center border-b border-gray-700 pb-2">
                                                        <h4 className="text-lg font-semibold text-white">Pricing Plan {index + 1}</h4>
                                                        {
                                                            (formData.pricing_plans || []).length > 1 && (
                                                                <Button
                                                                    type="button"
                                                                    py="py-1"
                                                                    px="px-5"
                                                                    width="w-34"
                                                                    disabled={isSubmitting}
                                                                    onClick={() => removePricingPlan(index)}
                                                                >
                                                                    Remove
                                                                </Button>
                                                            )
                                                        }
                                                    </div>

                                                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                                        <Input
                                                            label="Notes"
                                                            id={`plan_note_${index}`}
                                                            name={`plan_note_${index}`}
                                                            value={planDetails.note}
                                                            placeholder="Enter Your Notes"
                                                            disabled={isSubmitting}
                                                            onChange={(e) => handlePricingPlanChange(index, 'note', e.target.value)}
                                                        />
                                                        <Input
                                                            label="Duration"
                                                            id={`plan_duration_${index}`}
                                                            name={`plan_duration_${index}`}
                                                            value={planDetails.duration}
                                                            placeholder="Enter Your Duration"
                                                            disabled={isSubmitting}
                                                            onChange={(e) => handlePricingPlanChange(index, 'duration', e.target.value)}
                                                        />
                                                        <Input
                                                            type="number"
                                                            label="Price (₹)"
                                                            id={`plan_price_${index}`}
                                                            name={`plan_price_${index}`}
                                                            value={planDetails.price}
                                                            placeholder="e.g., 2999"
                                                            disabled={isSubmitting}
                                                            onChange={(e) => handlePricingPlanChange(index, 'price', e.target.value)}
                                                            min="0"
                                                        />
                                                    </div>
                                                    <div className="w-full font-urbanist">
                                                        <label
                                                            className={`block text-lg font-semibold mb-1 ${isSubmitting ? "text-gray-500" : "text-white"}`}
                                                        >
                                                            Features
                                                        </label>

                                                        <div className="w-full flex flex-wrap flex-row justify-start items-center gap-6">
                                                            {
                                                                (planDetails.features || []).map((pointDetails, pIndex) => {
                                                                    const isCheckStatus = (typeof pointDetails?.status === 'string' ? JSON.parse(pointDetails?.status || 'false') || false : pointDetails?.status)
                                                                    return (
                                                                        <div className={`flex flex-row items-center bg-gray-700 px-2 py-2 md:py-2 rounded-md gap-2`} key={pIndex}>
                                                                            <input
                                                                                type="checkbox"
                                                                                className="mt-0"
                                                                                name="status"
                                                                                checked={isCheckStatus}
                                                                                style={{ height: '1rem', width: '1rem' }}
                                                                                onChange={(event) => {
                                                                                    const checked = event.target.checked;
                                                                                    const feature_tags = [...planDetails.features];
                                                                                    feature_tags[pIndex]['status'] = checked;
                                                                                    handlePricingPlanChange(index, 'features', feature_tags)
                                                                                }}
                                                                            />
                                                                            <div className="text-white text-[0.75rem] font-normal font-urbanist leading-normal">
                                                                                {pointDetails.title}
                                                                            </div>
                                                                        </div>
                                                                    )
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }

                                    <Button
                                        type="button"
                                        width="w-full"
                                        onClick={addPricingPlan}
                                        disabled={isSubmitting}
                                    >
                                        + Add Another Service
                                    </Button>
                                </div>


                                <div className="flex flex-row flex-wrap">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Select Amenities :-
                                    </p>
                                    <div className="flex flex-row flex-wrap gap-4 justify-center w-full py-5">
                                        {
                                            amenityList.map((amenity, i) => {
                                                const selected = !!(_.find(formData?.amenities || [], ['title', amenity?.title]));
                                                const radiusClass = 'rounded-tl-md';
                                                return (
                                                    <div
                                                        key={i}
                                                        className={`w-32 flex flex-col justify-between rounded-xl ${radiusClass} relative overflow-hidden ${selected ? 'border border-white' : ""}`}
                                                        onClick={() => {
                                                            let amenities = [...formData?.amenities]
                                                            if (selected) {
                                                                amenities = amenities.filter((amenityDetails) => {
                                                                    return amenityDetails?.title !== amenity.title;
                                                                })
                                                            } else {
                                                                amenities.push({ ...amenity })
                                                            }

                                                            handleTagChange('amenities', amenities)

                                                        }}
                                                    >
                                                        {
                                                            selected &&
                                                            <div className="absolute h-5 w-5 bg-white right-0 rounded-bl-md px-1 py-1">

                                                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640" strokeWidth={4} fill="#22262E">
                                                                    <path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z" />
                                                                </svg>
                                                            </div>
                                                        }
                                                        <div
                                                            className={`w-full h-full bg-gradient-radial bg-black px-6 py-3 flex flex-col justify-between text-center text-xs`}
                                                        >
                                                            <div className="p-3">
                                                                <img className="w-full h-full object-contain object-center" src={amenity.img || `/assets/gym-facilities/amenities/Bike.png`} alt={amenity.title} />
                                                            </div>
                                                            <div className="text-white text-[0.85rem] mt-1">{amenity.title}</div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                                <div className="space-y-4">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Services Offered :-
                                    </p>
                                    {
                                        (formData.services || []).map((service, index) => (
                                            <div key={index} className="bg-[#22262E] border border-gray-600 p-4 rounded-lg space-y-4">
                                                <div className="flex justify-between items-center border-b border-gray-700 pb-2">
                                                    <h4 className="text-lg font-semibold text-white">Service {index + 1}</h4>
                                                    {
                                                        (formData.services || []).length > 1 && (
                                                            <Button
                                                                type="button"
                                                                py="py-1"
                                                                px="px-5"
                                                                width="w-34"
                                                                disabled={isSubmitting}
                                                                onClick={() => removeService(index)}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )
                                                    }
                                                </div>
                                                <FileUploader
                                                    id={`service-img-${index}`}
                                                    name={`service_img_${index}`}
                                                    label="Service Image"
                                                    uploadedImage={service.img || null}
                                                    required
                                                    maxFiles={1}
                                                    accept='.png, .jpg, .jpeg'
                                                    disabled={isSubmitting}
                                                    onChange={(e) => handleServiceChange(index, 'img', e.target.files)}
                                                />

                                                <Input
                                                    label="Service Title"
                                                    // subTitle='e.g., Personal Training'
                                                    id={`service-title-${index}`}
                                                    name={`service_title_${index}`}
                                                    value={service.title}
                                                    placeholder="Enter Your Service Title"
                                                    disabled={isSubmitting}
                                                    onChange={(e) => handleServiceChange(index, 'title', e.target.value)}
                                                />
                                            </div>
                                        ))
                                    }

                                    <Button
                                        type="button"
                                        width="w-full"
                                        onClick={addService}
                                        disabled={isSubmitting}
                                    >
                                        + Add Another Service
                                    </Button>
                                </div>

                                {/* Youtube Links */}
                                <div className="space-y-4">
                                    <p className='mt-4 w-full text-md text-left text-3xl text-white py-2 font-urbanist border-b border-dashed'>
                                        Youtube Links :-
                                    </p>
                                    {
                                        (formData.youtube_links || []).map((service, index) => (
                                            <div key={index} className="bg-[#22262E] border border-gray-600 p-4 rounded-lg space-y-4">
                                                <div className="flex justify-between items-center border-b border-gray-700 pb-2">
                                                    <h4 className="text-lg font-semibold text-white">Youtube Link {index + 1}</h4>
                                                    {
                                                        (formData.youtube_links || []).length > 1 && (
                                                            <Button
                                                                type="button"
                                                                py="py-1"
                                                                px="px-5"
                                                                width="w-34"
                                                                disabled={isSubmitting}
                                                                onClick={() => { removeYoutubeLink(index) }}
                                                            >
                                                                Remove
                                                            </Button>
                                                        )
                                                    }
                                                </div>

                                                <Input
                                                    type='url'
                                                    label="Youtube Link"
                                                    // subTitle='e.g., Personal Training'
                                                    id={`youtube-url-${index}`}
                                                    name={`youtube_url_${index}`}
                                                    value={service.link}
                                                    placeholder="Enter Your Youtube Link"
                                                    disabled={isSubmitting}
                                                    onChange={(e) => { handleYoutubeChange(index, 'link', e.target.value) }}
                                                    errorName={`youtube_links[${index}].link`}
                                                    errors={errors}
                                                />

                                                {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
                                                    <Input
                                                        label="Youtube Title"
                                                        id={`youtube-title-${index}`}
                                                        name={`youtube_title_${index}`}
                                                        value={service.title}
                                                        placeholder="Enter Your Youtube Title"
                                                        onChange={(e) => { handleYoutubeChange(index, 'title', e.target.value) }}
                                                        errorName={`youtube_links[${index}].title`}
                                                        errors={errors}
                                                    />
                                                    {/* <Input
                                                        type="number"
                                                        label="Youtube Video Viewer"
                                                        id={`youtube-views-${index}`}
                                                        name={`youtube_views_${index}`}
                                                        value={service.views}
                                                        placeholder="Enter Your Youtube Video Views"
                                                        disabled={isSubmitting}
                                                        onChange={(e) => { handleYoutubeChange(index, 'views', e.target.value) }}
                                                        min="0"
                                                        errorName={`youtube_links[${index}].views`}
                                                        errors={errors}
                                                    /> */}
                                                {/* </div> */}
                                            </div>
                                        ))
                                    }

                                    <Button
                                        type="button"
                                        width="w-full"
                                        disabled={isSubmitting}
                                        onClick={addYoutubeLink}
                                    >
                                        + Add Another Youtube Link
                                    </Button>
                                </div>

                                {/* FWPI Code of Ethics - Key Principles */}
                                <div className="font-urbanist">
                                    <label className="block font-semibold mb-2 text-white">
                                        FWPI Code of Ethics – Key Principles
                                    </label>
                                    <ul className="list-decimal list-inside grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-2 text-xs rounded-tr-sm rounded-2xl p-4 border border-white text-white">
                                        {
                                            codeOfEthicsList.map((code, index) => {
                                                return (
                                                    <li key={index}>{code}</li>
                                                )
                                            })
                                        }
                                    </ul>
                                </div>

                                {/* Code of Ethics Declaration */}
                                <Checkbox
                                    id="codeOfEthics"
                                    name="codeOfEthics"
                                    className='mt-0'
                                    label="I agree to uphold the FWPI Code of Ethics and pledge to maintain ethical, responsible, and professional conduct in all fitness and wellness practices."
                                    onChange={handleChange}
                                    errors={errors}
                                    checked={formData?.codeOfEthics}
                                    required
                                    disabled={isSubmitting}
                                />

                                {/* Submit and Clear Buttons */}
                                <div className="flex justify-center gap-6 max-w-2xl mx-auto">
                                    <Button
                                        type="button"
                                        disabled={!isValidUserName || !formData?.codeOfEthics || isSubmitting}
                                        loading={isSubmitting}
                                        onClick={(e) => {
                                            handleSubmit(e)
                                        }}
                                    >
                                        Submit
                                    </Button>

                                    {
                                        !isMyProfilePage &&
                                        <Button
                                            type="reset"
                                            disabled={isSubmitting}
                                            onClick={(e) => {
                                                handleReset(e)
                                            }}
                                        >
                                            Clear Form
                                        </Button>
                                    }
                                </div>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}
export { CreateGymProfile };
